export default __webpack_public_path__ + "static/media/github.46c74c35.svg";